import { Billing } from 'ui/components/buyer/patterns/Billing/Billing';

/**
 * 買い手請求情報
 */
export const BuyerBilling: React.FC = () => {
    return <Billing />;
};
